import GenericDB from './generic-db'

export default class AdCreativeLinkDataCallToActionDB extends GenericDB {
  constructor() {
    super('adCreativeLinkDataCallToAction')
  }

  // Here you can extend AdCreativeLinkDataCallToActionDB with custom methods
}
